import { WebAppConfig } from '..';

const config: WebAppConfig = {
  COMMONEVENT_KINESIS_URL: 'https://kinesis-api.anywhereexpert.us',
};

export default config;



// WEBPACK FOOTER //
// ./packages/web-app/src/config/prod/index.ts